module.exports = __webpack_public_path__ + "static/media/tgle-Katharsis-dark.b3d3360d.png";